import { MbscCalendarEvent } from "@mobiscroll/react";

type CompareEventsByScheduleRenderOrderInput = {
  event1: MbscCalendarEvent;
  event2: MbscCalendarEvent;
  scheduleRenderOrderById: ReadonlyMap<number, number>;
};

export function compareEventsByScheduleRenderOrder({
  event1,
  event2,
  scheduleRenderOrderById
}: Readonly<CompareEventsByScheduleRenderOrderInput>): number {
  const event1Id = Number(event1.id);
  const event2Id = Number(event2.id);
  const event1Rank = scheduleRenderOrderById.get(event1Id) ?? Number.MAX_SAFE_INTEGER;
  const event2Rank = scheduleRenderOrderById.get(event2Id) ?? Number.MAX_SAFE_INTEGER;

  if (event1Rank !== event2Rank) {
    return event1Rank - event2Rank;
  }

  return 0;
}
